import React from 'react';
import AddToCalendar from 'react-add-to-calendar';
import styles from './Dates.module.scss';

const ImportantDate = ({ year, month, day, title, date }) => (
    <div className={styles['important-date-wrapper']}>
        <div className={styles['date-wrapper']}>
            <span>{month}</span>
            <span>{day}</span>
        </div>
        <div className={styles['important-date-title']}>
            <AddToCalendar event={{
                title: title,
                description: '',
                location: 'Singapore',
                startTime: date,
                endTime: date
            }} buttonWrapperClass={styles['date-btn-wrapper']} buttonLabel={title}/>
        </div>
    </div>
);

const Dates = () => (
    <div className={styles['dates-wrapper']}>
        <div className={styles['dates-header-wrapper']}>
            <h3>Important Dates</h3>
            <p><b>(AOE Time)</b></p>
        </div>
        <div>
            <ImportantDate year='2021' month='Nov' day='24' date='2021-11-25T00:00-11:00' title='Paper Submission Due' />
            <ImportantDate year='2022' month='Feb' day='06' date='2022-02-06T00:00-11:00' title='Rebuttal Due From Authors' />
            <ImportantDate year='2022' month='Feb' day='15' date='2022-02-16T00:00-11:00' title='Notification of Paper Acceptance' />
            <ImportantDate year='2022' month='Mar' day='10' date='2022-03-11T00:00-11:00' title='Camera-ready Papers Due' />
            <ImportantDate year='2022' month='Mar' day='31' date='2022-03-31T00:00-11:00' title='Author Registration Deadline' />
            <ImportantDate year='2022' month='May' day='22' date='2022-05-23T00:00-11:00' title='Workshop Starts' />
        </div>
    </div>
);

export default Dates;